// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpControlIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpControlIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpControlIconOutlined = function DrrpControlIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpControlIconOutlinedSvg
  }));
};

DrrpControlIconOutlined.displayName = 'DrrpControlIconOutlined';
export default React.forwardRef(DrrpControlIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpControlIconOutlined.js
// module id = 2495
// module chunks = 0